import { createSelector } from 'reselect';
import { configSelector } from './config';

export const getVisibleCampaignFilters = createSelector(
    configSelector,
    config => {
        const result = {};

        config?.buyers?.listing?.discoveryEnhancer?.visibleCampaign.forEach(ele => {
            result[ele.filterAttr] = {
                name: ele.filterHeading,
                valueName: ele.filterName
            };
        });

        return result;
    }
);

export const getVisibleCampaignTags = createSelector(
    configSelector,
    config => {
        const result = {};

        config?.buyers?.listing?.discoveryEnhancer?.visibleCampaign.forEach(ele => {
            result[ele.labelId] = {
                labelName: ele.labelName,
                labelColor: ele.labelColor,
                labelTextColor: ele.labelTextColor
            };
        });

        return result;
    }
);
